const DEVICE_TYPES = {
    phone: 'phone',
    phablet: 'phablet',
    tablet: 'tablet',
    desktop: 'desktop',
};
const containsAnyUa = (substrings) => (ua) => {
    if (typeof ua !== 'string') {
        return false;
    }
    const normalizedUa = ua.toLowerCase();
    return substrings
        .map((substring) => substring.toLowerCase())
        .some((substring) => normalizedUa.includes(substring));
};
const isTablet = containsAnyUa(['ipad', 'kfapwi']);
const isPhablet = containsAnyUa(['nexus']);
const isMobile = containsAnyUa(['iphone', 'mobile']);
const guessUserAgentInfo = (userAgent) => {
    if (isTablet(userAgent)) {
        return { deviceType: DEVICE_TYPES.tablet, width: 660 };
    }
    if (isPhablet(userAgent)) {
        return { deviceType: DEVICE_TYPES.phablet, width: 420 };
    }
    if (isMobile(userAgent)) {
        return { deviceType: DEVICE_TYPES.phone, width: 320 };
    }
    return { deviceType: DEVICE_TYPES.desktop, width: 1024 };
};
export default guessUserAgentInfo;
//# sourceMappingURL=guessUserAgentInfo.js.map
// @zapier/universal-layout@11.2.3 (b1a6e8603)
